exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ActivityModuleRecord {\n  padding: 0.16rem 0.12rem;\n}\n.ActivityModuleRecord > div {\n  background-color: #fff;\n  border-radius: 0.16rem;\n}\n.ActivityModuleRecord > div .ActivityModuleRecord_title {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.14rem;\n  color: #999999;\n  line-height: 0.21rem;\n  padding: 0.16rem;\n  text-align: center;\n}\n.ActivityModuleRecord > div .ActivityModuleRecord_title > div {\n  -ms-flex: 1 1;\n      flex: 1 1;\n}\n.ActivityModuleRecord > div .FindItem {\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.14rem;\n  color: #333;\n  line-height: 0.21rem;\n  padding: 0.16rem;\n  text-align: center;\n}\n.ActivityModuleRecord > div .FindItem > div {\n  -ms-flex: 1 1;\n      flex: 1 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/ActivityModule/record/index.less
// module id = 1576
// module chunks = 0